module.exports = __webpack_public_path__ + "static/Group 7125-cda484483493cd0d98b755cde9d2dce3.png";